import React from 'react'

const VideoGallery = () => {
    return (
        <div>
            <div className="full-row bg-white" style={{ paddingTop: '150px' }}>
                <div className="container" >
                    <div className="row">
                        <div className="col">
                            <h2 className="text-secondary double-down-line text-center">Video Gallery</h2>
                        </div>
                    </div>

                    <div className="row  mt-5">
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/uVQ5wU8vJPw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/C14CJP72a1A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/FZljlS1VkDc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>


                    </div>

                    <div className="row  mt-5">
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/uJfNK0XOboU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/4qncw5araj4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/xrqwfw8ha4k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>


                    </div>

                    <div className="row  mt-5">
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/nmjQLceJejY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/4ezrDNUjbw4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/6DdEM_oRweA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>


                    </div>

                    <div className="row  mt-5">
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/L8HXbvQO-Vk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/RP-YQt5pCa4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <iframe width="380" height="320" src="https://www.youtube.com/embed/i2TU7PrG-z0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>


                    </div>



                </div>
            </div>


        </div>
    )
}

export default VideoGallery
